import axios, { AxiosError } from "axios";
import apiIndex from "~/api/index";
import apiRequest from "~/api/request";
import { ACCESS_TOKEN, REFRESH_TOKEN } from "~/enum/cache/cookie";
import { PLATFORM_SOURCE_REGISTER } from "~/enum/cache/sessionStorage";
import { API_URL } from "~/env";
import { axiosConfig } from "~/utils/axios-utils";
import Cookie from "~/utils/cookie";

// orlando备注：
// vue2和3，在这儿有点区别，vue 2大部分是通过nuxt.config的配置注入axios

export default defineNuxtPlugin(() => {
  // 创建一个基本的 Axios 实例
  const axiosInstance = axios.create({
    baseURL: API_URL,
    timeout: 60000,
  });

  // Error handler
  const onError = (error: AxiosError) => {
    const response = error.response;
    const status = response?.status;
    // Need login
    if (status === 401 || status === 417 || status === 406) {
      Cookie.remove(ACCESS_TOKEN);
      Cookie.remove(REFRESH_TOKEN);
      toLogin();
    }
  };

  // 配置 Axios 实例
  const configuredAxios = axiosConfig(axiosInstance, { onError });

  // 创建 API 实例
  const api = apiIndex(configuredAxios);

  // 创建 Request 实例
  const request = apiRequest(configuredAxios);

  // 提供给 Nuxt app
  // 只使用一种方式提供值，避免属性重复定义错误
  return {
    provide: {
      api,
      Request: request,
    },
  };
});

// Login redirect function
export const toLogin = () => {
  if (process.server) return;

  const source = sessionStorage.getItem(PLATFORM_SOURCE_REGISTER) || "";
  let platform = "";
  if (source) {
    platform = `&platform=${source}`;
  }

  let loginPath = "/login";
  if (location.pathname.includes("/game/")) {
    loginPath = "/game/login";
  }
  if (location.href.includes("secretKey")) {
    loginPath = "/h5/siq/home";
  }

  const url = new URL(loginPath || "/login", location.origin);
  url.searchParams.set("redirect", location.href);
  location.href = url.href + platform;
};

// Type definitions
export type ApiIndex = ReturnType<typeof apiIndex>;
export type RequestType = ReturnType<typeof apiRequest>;
